import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { NavConfig, Perspective, PERSPECTIVE_LABELS } from '../../nav/navTypes';
import { computeVisibleGroups } from '../../nav/navSelectors';
import { iconFor } from '../../nav/navIcons';

interface Props {
  config: NavConfig;
  editRole: Perspective;
}

/**
 * Scaled-down mirror of the edited role's sidebar. Computed with role 'admin'
 * so only the `!hidden` filter applies (admins pass every minRole) — matching
 * the prototype's preview semantics. Updates live on every config change.
 */
export default function NavLivePreview({ config, editRole }: Props) {
  const groups = computeVisibleGroups(config, editRole, 'admin');
  return (
    <Box
      data-testid="nav-live-preview"
      sx={{ border: '1px solid', borderColor: 'divider', p: 1.5, position: 'sticky', top: 16 }}
    >
      <Typography variant="subtitle2" gutterBottom>
        Vorschau · {PERSPECTIVE_LABELS[editRole]}
      </Typography>
      {groups.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          Keine sichtbaren Seiten.
        </Typography>
      ) : (
        groups.map((g) => (
          <Box key={g.id} sx={{ mb: 1 }}>
            <Typography variant="overline" color="text.secondary">
              {g.name}
            </Typography>
            <List dense disablePadding>
              {g.items.map((it) => (
                <ListItem key={it.id} disablePadding sx={{ py: 0.25 }}>
                  <ListItemIcon sx={{ minWidth: 28 }}>{iconFor(it.id)}</ListItemIcon>
                  <ListItemText primary={it.label} />
                </ListItem>
              ))}
            </List>
          </Box>
        ))
      )}
    </Box>
  );
}
